const studentsTemplate = '/templates/student--upload--template.xlsx'
const gradesTemplate = '/templates/grades--upload--template.xlsx'
export {studentsTemplate, gradesTemplate}